<div class="grid grid-cols-1 lg:grid-cols-3 gap-xl mb-24 items-stretch">
  <div
    *ngFor="let card of listCards; let i = index"
    class="h-full">
    <div class="p-base bg-neutral-lighter border-t-8 border-neutral-dark h-full flex flex-col">
      <ng-container [ngSwitch]="card.icon">
        <!-- Icono Upload -->
        <svg *ngSwitchCase="'upload'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 -0.5 16 16" stroke="#000000" aria-hidden="true" class="w-6 h-6 lg:w-9 lg:h-9 mt-base mb-lg">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12.1875 8.90625v-1.640625a2.109375 2.109375 0 0 0 -2.109375 -2.109375h-0.9375A0.703125 0.703125 0 0 1 8.4375 4.453125v-0.9375a2.109375 2.109375 0 0 0 -2.109375 -2.109375H5.15625m4.21875 7.5 -1.875 -1.875m0 0 -1.875 1.875m1.875 -1.875v3.75m-0.9375 -9.375H3.515625c-0.388125 0 -0.703125 0.315 -0.703125 0.703125v10.78125c0 0.388125 0.315 0.703125 0.703125 0.703125h7.96875c0.388125 0 0.703125 -0.315 0.703125 -0.703125V7.03125a5.625 5.625 0 0 0 -5.625 -5.625Z" stroke-width="1"></path>
        </svg>

        <!-- Icono Busqueda CV -->
        <svg *ngSwitchCase="'searchCV'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 -0.5 16 16" stroke="#000000" aria-hidden="true" class="w-6 h-6 lg:w-9 lg:h-9 mt-base mb-lg">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.375 5.625h2.34375M9.375 7.5h2.34375M9.375 9.375h2.34375M2.8125 12.1875h9.375a1.40625 1.40625 0 0 0 1.40625 -1.40625V4.21875A1.40625 1.40625 0 0 0 12.1875 2.8125h-9.375a1.40625 1.40625 0 0 0 -1.40625 1.40625v6.5625A1.40625 1.40625 0 0 0 2.8125 12.1875Zm3.75 -6.328125a1.171875 1.171875 0 1 1 -2.34375 0 1.171875 1.171875 0 0 1 2.34375 0Zm0.8087500000000001 3.96a4.2006250000000005 4.2006250000000005 0 0 1 -1.98125 0.49312500000000004 4.2006250000000005 4.2006250000000005 0 0 1 -1.98 -0.49312500000000004 2.11 2.11 0 0 1 3.96125 0Z" stroke-width="1"></path>
        </svg>

        <!-- Icono Búsqueda Oferta --> 
        <svg  *ngSwitchCase="'searchJobOffer'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 -0.5 16 16" stroke="#000000" aria-hidden="true" class="w-6 h-6 lg:w-9 lg:h-9 mt-base mb-lg">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12.1875 8.90625v-1.640625a2.109375 2.109375 0 0 0 -2.109375 -2.109375h-0.9375A0.703125 0.703125 0 0 1 8.4375 4.453125v-0.9375a2.109375 2.109375 0 0 0 -2.109375 -2.109375H5.15625m0 7.96875h4.6875m-4.6875 1.875H7.5M6.5625 1.40625H3.515625c-0.388125 0 -0.703125 0.315 -0.703125 0.703125v10.78125c0 0.388125 0.315 0.703125 0.703125 0.703125h7.96875c0.388125 0 0.703125 -0.315 0.703125 -0.703125V7.03125a5.625 5.625 0 0 0 -5.625 -5.625Z" stroke-width="1"></path>
        </svg>
        
        <!-- Icono Lupa -->
        <svg *ngSwitchCase="'search'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 -0.5 16 16" stroke="#000000" aria-hidden="true" class="w-6 h-6 lg:w-9 lg:h-9 mt-base mb-lg">
          <path stroke-linecap="round" stroke-linejoin="round" d="m13.125 13.125 -3.248125 -3.248125m0 0A4.6875 4.6875 0 1 0 3.2474999999999996 3.2474999999999996a4.6875 4.6875 0 0 0 6.629375 6.629375Z" stroke-width="1"></path>
        </svg>

        <!-- Icono Usuarios --> 
        <svg *ngSwitchCase="'users'" class="w-6 h-6 lg:w-9 lg:h-9 mt-base mb-lg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.5 -0.5 16 16" stroke="#000000" aria-hidden="true">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.375 11.955a5.862500000000001 5.862500000000001 0 0 0 1.640625 0.23249999999999998 5.835625 5.835625 0 0 0 2.5756250000000005 -0.595 2.578125 2.578125 0 0 0 -4.708125 -1.558125M9.375 11.955v-0.001875c0 -0.6956249999999999 -0.17812499999999998 -1.35 -0.49125 -1.91875M9.375 11.955v0.06625A7.6987499999999995 7.6987499999999995 0 0 1 5.390000000000001 13.125c-1.456875 0 -2.82 -0.403125 -3.9837499999999997 -1.10375l-0.000625 -0.068125a3.984375 3.984375 0 0 1 7.4775 -1.91875M7.5 3.984375a2.109375 2.109375 0 1 1 -4.21875 0 2.109375 2.109375 0 0 1 4.21875 0Zm5.15625 1.40625a1.640625 1.640625 0 1 1 -3.28125 0 1.640625 1.640625 0 0 1 3.28125 0Z" stroke-width="1"></path>
        </svg>

        <!-- Icono por defecto -->
        <svg
          *ngSwitchDefault
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 48 48"
          class="w-6 h-6 lg:w-9 lg:h-9 mt-base mb-lg"
          aria-hidden="true"
          focusable="false">
          <circle
            cx="24"
            cy="24"
            r="20"
            stroke="currentColor"
            stroke-width="4"
            fill="none" />
        </svg>
      </ng-container>

      <!-- Título -->
      <h3 class="c-h3">{{ card.title }}</h3>

      <!-- Descripción -->
      <div class="prose max-w-none mb-base flex-grow">
        <p>{{ card.description }}</p>
      </div>

      <!-- Botón -->
      <desy-button
        [routerLink]="card.link.route"
        type="button"
        classes="c-button c-button--transparent my-2 whitespace-normal"
        [text]="card.link.text"></desy-button>
    </div>
  </div>
</div>
